module.exports = __webpack_public_path__ + "static/img/shangjia.b86efc2a.png";